<div class="contact-us-form-wrap">
    <h1 class="font-light">Take the <span class="font-black">First Step.</span></h1>

    <p class="font-light description">
        Whether pursuing modernization of your enterprise application estate or seeking a modern, more efficient approach to application management, CDS is here to help.<br />
        When you’re ready to take the next step, fill out the form below and we’ll contact you to discuss more. You can also email us:
        <a href="mailto:CDS_SUPPORT&#64;activenetwork.com" class="text-blue-600 underline">CDS_SUPPORT&#64;activenetwork.com</a>
    </p>

    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-[24px] gap-y-[32px]">
            <div class="form-group">
                <label class="block font-bold"> Name <span class="text-red-500">*</span> </label>
                <input type="text" formControlName="name" class="w-full rounded-lg font-normal"
                    [class.border-red-500]="isInvalid('name')" placeholder="e.g. Sam Smith" maxlength="30" [imask]="nameMask" />
                <div *ngIf="isInvalid('name')" class="text-red-500 text-sm mt-1">Please fill in your name.</div>
            </div>

            <div class="form-group">
                <label class="block font-bold"> Company Name <span class="text-red-500">*</span> </label>
                <input type="text" formControlName="companyName" class="w-full rounded-lg font-normal" [class.border-red-500]="isInvalid('companyName')" maxlength="50" />
                <div *ngIf="isInvalid('companyName')" class="text-red-500 text-sm mt-1">Please fill in your company name.</div>
            </div>

            <div class="form-group">
                <label class="block font-bold"> Email <span class="text-red-500">*</span> </label>
                <input type="email" formControlName="email" class="w-full rounded-lg font-normal" [class.border-red-500]="isInvalid('email')" maxlength="50" />
                <div *ngIf="contactForm.controls['email'].touched && contactForm.controls['email'].getError('required')" class="text-red-500 text-sm mt-1">Please fill in your email address.</div>
                <div *ngIf="contactForm.controls['email'].touched && contactForm.controls['email'].getError('email')" class="text-red-500 text-sm mt-1">Please fill a valid email address.</div>
            </div>

            <div class="form-group">
                <label class="block font-bold">Phone</label>
                <ngx-intl-tel-input
                    id="phoneNumberInput"
                    class="phone-number-input w-full rounded-lg font-normal"
                    [preferredCountries]="[CountryISO.UnitedStates, CountryISO.Canada]"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.UnitedStates"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    [separateDialCode]="true"
                    [numberFormat]="PhoneNumberFormat.National"
                    name="phone"
                    formControlName="phone"
                    (change)="formatPhoneNumber()"
                ></ngx-intl-tel-input>
                <div class="text-red-500 text-sm mt-1" *ngIf="contactForm.controls['phone'].value && contactForm.controls['phone'].invalid">Please fill a valid phone.</div>
            </div>
        </div>

        <div class="form-group my-[32px]">
            <label class="block font-bold"> Note <span class="text-red-500">*</span> </label>
            <textarea rows="4" formControlName="note" class="w-full rounded-lg font-normal" [class.border-red-500]="isInvalid('note')" maxlength="500"></textarea>
            <div *ngIf="isInvalid('note')" class="text-red-500 text-sm mt-1">Please fill in your note.</div>
        </div>

        <div>
            <button type="submit" class="bg-blue-600 text-white px-8 py-2 rounded-full hover:bg-blue-700 transition disabled:opacity-50">Submit</button>
        </div>
    </form>
</div>
